import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Workbook } from 'exceljs';
import { FormBuilder, Validators } from '@angular/forms';
import {
  Regions,
  Estados,
  sucursales,
} from 'src/app/modules/cases/components/create-case/ras-form/ras-form.utils';
import { FindSucursalDataService } from '../../../services/find-sucursal-data.service';

export interface ISucursal {
  nombre_institucion: any;
  nombre_oficina: any;
  codigo_oficina: any;
  estatus_oficina: any;
  pais_ubicacion: any;
  nombre_parroquia: any;
  nombre_municipio: any;
  nombre_estado: any;
  cod_inst: any;
}

@Component({
  selector: 'app-sucursal-ras',
  templateUrl: './sucursal-ras.component.html',
  styleUrls: ['./sucursal-ras.component.scss'],
})
export class SucursalRasComponent implements OnInit {
  @Input() data: { task: any };
  public estados = Estados;
  public sucursal = sucursales;
  form;
  bancos: ISucursal[] = [];
  bancosFiltered = [];
  onKey(value: string) {
    let filter = value.toLowerCase();
    this.bancosFiltered = this.bancos.filter(
      (option) => JSON.stringify(option).toLowerCase().indexOf(filter) != -1
    );
  }

  public regions = Regions;
  constructor(
    private fb: FormBuilder,
    private readonly sucursalFindData: FindSucursalDataService
  ) {}

  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.autoCompleteForm(values);
  }

  autoCompleteForm(values) {
    //filtramos solo el texto de los estados
    for (let e of this.estados) {
      this.est.push(e.estado);
    }
    try {
      if (values) {
        //filtramos los municipoos del estado seleccionado que vienen de values
        this.estMun = this.estados.filter((es) => {
          return es.estado == values.estado;
        });
        //una vez obtenido el estado con sus municipios pasamos solo el texto de los municipios
        for (let e of this.estMun[0].municipio) {
          this.mun.push(e.municipio);
        }
        //tomamos el municipio seleccionado de values y filtramos solo las parroquias
        this.munParr = this.estMun[0].municipio.filter((munici) => {
          return munici.municipio == values.municipio;
        });
        this.parr = this.munParr[0].parroquias;
      }
    } catch (err) {
      console.log(err);
    }
    this.form = this.fb.group({
      sucursal: [values ? values.sucursal : '', [Validators.required]],
      telefono: [values ? values.telefono : '', [Validators.required]],
      direccion: [values ? values.direccion : '', [Validators.required]],
      region_de_la_alerta: [
        values ? values.region_de_la_alerta : '',
        [Validators.required],
      ],
      estado: [values ? values.estado : '', [Validators.required]],
      municipio: [values ? values.municipio : '', [Validators.required]],
      parroquia: [values ? values.parroquia : '', [Validators.required]],
    });
  }
  est = [];
  estMun = [];
  mun = [];
  munParr = [];
  parr = [];
  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }
  //cuando cambia el estado de el estado borra municipio y parroquia
  changeEstado(estad) {
    this.form.controls.municipio.setValue(undefined);
    this.form.controls.parroquia.setValue(undefined);
    this.mun = [];
    this.estMun = this.estados.filter((es) => {
      return es.estado == estad;
    });
    for (let e of this.estMun[0].municipio) {
      this.mun.push(e.municipio);
    }
  }
  //cuando cambia el estado de el municipio actualiza la tabla de parroquia
  changeMunicipio(mun) {
    if (this.estMun[0]) {
      this.munParr = this.estMun[0].municipio.filter((munici) => {
        return munici.municipio == mun;
      });
      this.parr = this.munParr[0].parroquias;
    }
  }
  async setvaluesDirTlf() {
    let data = await this.sucursalFindData.takeData(this.form.value.sucursal);
    this.form.controls.telefono.setValue(data.tlf);
    this.form.controls.direccion.setValue(data.dir);
  }
}
